<template>
  <div
    class="soha-resume-tag"
    :style="resumeTagStyle"
  >
    <span
      :class="`svg-icon svg-icon-md mt-2 pr-2 svg-icon-${
        color ? color : 'gray'
      }`"
    >
      <inline-svg src="/media/svg/soha/icons/tag.svg" />
    </span>
    <soha-limited-text
      v-if="limitTextShow && !fullText"
      class="my-auto"
      :limit="limitTextShow"
      :text="label"
    />
    <span
      v-else
      class="my-auto"
    >{{ label }}</span>
    <span
      v-if="tagId"
      :class="`svg-icon mt-1 ml-2 svg-icon-${
        color ? color : 'gray'
      }`"
      name="deleteTag"
      @click="$emit('onDeleteClicked')"
    >
      <inline-svg src="/media/svg/soha/icons/times.svg" />
    </span>
  </div>
</template>

<script>
import "@/assets/css/components/tag/tag.css";

export default {
  name: "Tag",

  props: {
    fullText: {
      default: false,
      type: Boolean,
    },
    color: {
      type: String,
      require: true,
      default: null,
    },
    label: {
      type: String,
      require: true,
      default: null,
    },
    limitTextShow: {
      type:Number, 
      default: null,
    },
    tagId: {
      type: [String, Number],
      default: null,
    },
  },

  emits: ['onDeleteClicked'],

  data() {
    return {};
  },

  computed: {
    resumeTagStyle: function () {
      return {
        "background-color": `var(--tag-light-${this.color ?? "gray"}-color)`,
        "color": `var(--tag-dark-${this.color ?? "gray"}-color)`,
      };
    },
  },
};
</script>
